const closeQuestoins = items => {
    items.forEach(item => {
        item.classList.remove("open");
    });
}

const accordionHandler = () => {
    const btns = document.querySelectorAll(".group-name, .single-question");

    btns.forEach(btn => {
        // Obsługuje kliknięcie myszką
        btn.addEventListener("click", e => {
            e.preventDefault();
            btn.classList.toggle("open");
        });

        // Obsługuje naciśnięcie klawisza Enter lub Space
        btn.addEventListener("keydown", e => {
            if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                e.preventDefault(); // Zapobiega domyślnej akcji (np. przewijaniu strony dla Space)
                btn.classList.toggle("open");
            }
        });
    });
}

export default accordionHandler;
